import Frames from "@frog/source/engine/animating/Frames.js"

export default {
    "frames": Frames.run({
        "tweentime": 80,
        "images": [
            require("./fireanim-torchfancy-flame2-0000.png"),
            require("./fireanim-torchfancy-flame2-0001.png"),
            require("./fireanim-torchfancy-flame2-0002.png"),
            require("./fireanim-torchfancy-flame2-0003.png"),
            require("./fireanim-torchfancy-flame2-0004.png"),
            require("./fireanim-torchfancy-flame2-0005.png"),
            require("./fireanim-torchfancy-flame2-0006.png"),
            require("./fireanim-torchfancy-flame2-0007.png"),
        ]
    })
}
